import type { SnEvent } from './types'

/** Months either side of now that `/games/dates` is queried for. */
const WINDOW_MONTHS = 6

const addMonths = (date: Date, months: number): Date => {
  const shifted = new Date(date)
  shifted.setMonth(shifted.getMonth() + months)
  return shifted
}

/**
 * The `starts_at` values of events falling inside the same ±6 month window
 * `/games/dates` is queried for.
 *
 * Games are fetched for a bounded window; events arrive unwindowed. Without
 * this, an event years out could decide a tab that games never saw a candidate
 * for — so both sides of the tab decision are narrowed to the same question.
 *
 * Missing and unparseable dates are dropped rather than passed through as NaN.
 */
export const eventStartsWithinWindow = (
  events: SnEvent[] | null | undefined,
  now: Date = new Date()
): string[] => {
  const start = addMonths(now, -WINDOW_MONTHS).getTime()
  const end = addMonths(now, WINDOW_MONTHS).getTime()

  return (events ?? [])
    .map((event) => event?.starts_at)
    .filter((startsAt): startsAt is string => {
      if (!startsAt) {
        return false
      }
      const time = new Date(startsAt).getTime()
      return !Number.isNaN(time) && time >= start && time <= end
    })
}
